/**
 * FieldsetElement — F12.H T12.H.3.
 *
 * Fieldset — semantyczny <fieldset> z opcjonalną legendą (<legend>).
 * Używany do logicznego grupowania pól w formularzu (a11y) — np.
 * „Dane osobowe", „Adres do faktury".
 *
 * Settings: { legend?, padding?: 'sm'|'md'|'lg' }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

const PADDING_CLASS: Record<string, string> = {
  sm: 'p-2',
  md: 'p-4',
  lg: 'p-6',
};

export const FieldsetElement: LayoutElementDefinition = {
  type: 'fieldset',
  category: 'kontenery',
  isContainer: true,
  label: 'Fieldset',
  icon: 'Group',
  defaultSettings: () => ({
    legend: 'Grupa pól',
    padding: 'md',
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as {
      legend?: string;
      padding?: 'sm' | 'md' | 'lg';
    };
    const paddingCls = PADDING_CLASS[settings.padding ?? 'md'] ?? 'p-4';
    const isBuilder = mode === 'builder';

    return (
      <fieldset
        className={`rounded-lg border border-border-primary ${paddingCls} ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition' : ''}`}
        data-testid={`fieldset-element-${element.id}`}
        data-element-type="fieldset"
      >
        {settings.legend && (
          <legend className="px-2 text-xs font-semibold uppercase tracking-wide text-text-secondary">
            {settings.legend}
          </legend>
        )}
        {children.length > 0 ? (
          <div className="space-y-3">{children}</div>
        ) : isBuilder ? (
          <p className="text-xs italic text-text-muted">(fieldset pusty — przeciągnij pola)</p>
        ) : null}
      </fieldset>
    );
  },
};
